// extracted by mini-css-extract-plugin
module.exports = {"container":"Home_container__2XUrO"};